<template>
  <v-card elevation="8" rounded>
    <v-data-table
      :headers="headers"
      :items="substances"
      hide-default-footer
      no-data-text="..."
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title class="mr-4" v-if="substances.length">
            <span v-if="$vuetify.breakpoint.smAndUp">
              {{ $t("searchRules.values") }}
            </span>
          </v-toolbar-title>
          <v-toolbar-title class="mr-4" v-else>
            {{ $t("showSubstance.values.info") }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <slot v-if="substances.length"></slot>
        </v-toolbar>
      </template>
      <template
        v-for="(header, i) in massiveValues"
        v-slot:[`item.${header}`]="{ item }"
      >
        <div :key="header + i">
          <div v-if="typeof item[header] === 'string'">
            <massive-item :valueItem="item[header]"></massive-item>
          </div>
        </div>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import MassiveItem from "./TableValueMassiveItem.vue";

export default {
  data() {
    return {};
  },
  props: {
    headers: Array,
    substances: Array,
    massiveValues: Array,
  },
  components: {
    MassiveItem,
  },
};
</script>